<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-8 col-md-10">
            <p class="text-white mt-3 mb-4">
              Aqui você vê com detalhes todo o programa de acompanhamento de seu
              batch. Para que a gente consiga atender sua startup da melhor
              forma possível, pedimos seu comprometimento em responder as
              tarefas do batch.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div v-if="batch">
        <div class="row">
          <div class="col-12">
            <startup-dashboard-stats :data="batch" />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-12">
            <past-tasks :batchId="batch.id" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StartupDashboardStats from "@/components/StartupDashboardStats";
import PastTasks from "@/components/StartupDashboard/PastTasks";
import api from "@/services/api";

export default {
  name: "batch_acompanhamento",
  components: {
    StartupDashboardStats,
    PastTasks,
  },
  data() {
    return {
      batch: "",
    };
  },
  async mounted() {
    const loaderBatch = this.$loading.show({
      container: this.$refs.batch_container,
      width: 90,
      height: 90,
    });
    await this.loadBatch();
    loaderBatch.hide();
  },
  methods: {
    async loadBatch() {
      try {
        const { data: batch } = await api.get(
          `/startup-batches/${this.$route.params.id}?name=true`
        );
        if (!batch) {
          this.$toasted.error("Batch não encontrado");
          this.$router.push("/startup/batches");
          return;
        }
        this.batch = batch;
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao carregar informações do batch");
        this.$router.push("/startup/batches");
      }
    },
  },
};
</script>
